export default {
    'EMPLOYER_STATUSES': {
        LABEL: 'Client Statuses',
        DESCRIPTION: 'Drag and drop statuses to re-order.'
    },
    EMPLOYER_STATUS_CHANGE_REASON: {
        LABEL: "Select statuses which need a reason when client status was changed to",
    },
    'CANDIDATE_STATUSES': {
        LABEL: 'Candidate Statuses',
        DESCRIPTION: 'Drag and drop statuses to re-order.'
    },
    'CANDIDATE_TYPES': {
        LABEL: 'Candidate Types',
        DESCRIPTION: 'Do you have different types/categories of candidates? Please input them here.'
    },
    'EMPLOYER_TYPES': {
        LABEL: 'Client Types',
        DESCRIPTION: 'Do you have different types/categories of clients? Please input them here.'
    },
    'CANDIDATE_TAGS': {
        LABEL: 'Candidate Taglist',
        DESCRIPTION: 'A list of tags to keep track of for candidates.'
    },
    'EMPLOYER_TAGS': {
        LABEL: 'Client Taglist',
        DESCRIPTION: 'A list of tags to keep track of for clients.'
    },
    'CANDIDATE_ADMIN_CHECKLIST': {
        LABEL: 'Candidate Admin Checklist',
        DESCRIPTION: 'A list of items to keep track of for candidates. This checklist will appear in the admin tab for each candidate. Drag and drop an item to re-order..'
    },
    'EMPLOYER_ADMIN_CHECKLIST': {
        LABEL: 'Client Admin Checklist',
        DESCRIPTION: 'A list of items to keep track of for clients. This checklist will appear in the admin tab for each client. Drag and drop an item to re-order..'
    },
    'AGENCY_LOCATIONS': {
        LABEL: 'Does your agency serve multiple distinct locations and would you like to divide the system by location? If so, please enter your different locations'
    },
    CANDIDATE_STATUS_CHANGE_REASON: {
        LABEL: "Select statuses which need a reason when candidate status was changed to",
    },
    EMPLOYER_SECOND_STATUSES: {
        LABEL: 'Client Secondary Statuses',
    },
    CANDIDATE_SECOND_STATUSES: {
        LABEL: 'Candidate Secondary Statuses',
    },
    'CANDIDATE_TABLE_FIELD': {
        LABEL: 'Fields which are showed in the Candidate table of agency dashboard',
        DESCRIPTION: 'Drag and drop fields to re-order.'
    },
    'EMPLOYER_TABLE_FIELD': {
        LABEL: 'Fields which are showed in the Client table of agency dashboard',
        DESCRIPTION: 'Drag and drop fields to re-order.'
    },
    'REFERENCE_TABLE_FIELD': {
        LABEL: 'Fields which are showed in the Reference table of agency dashboard',
        DESCRIPTION: 'Drag and drop fields to re-order.'
    },
    PLACEMENT_JOB_TABLE_FIELDS: {
        LABEL: 'Fields which are showed in the Placement Job table of agency dashboard',
        DESCRIPTION: 'Drag and drop fields to re-order.'
    },
    USE_ADMIN_NOTES_IN_INTAKE_NOTES: {
        LABEL: "Use admin notes in Client Intake Notes areas"
    },
    USE_ADMIN_NOTES_IN_INTERVIEW_NOTES: {
        LABEL: "Use admin notes in Candidate Intake Notes areas"
    },
    EMPLOYER_ADMIN_SHARE_VIEWS: {
        LABEL: "Use same views of employer table for all admin"
    },
    CANDIDATE_CAN_NOT_MODIFY_EXPIRE_DATE: {
        LABEL: "Candidate cannot modify expire date of document"
    },
    CANDIDATE_ADMIN_SHARE_VIEWS: {
        LABEL: "Use same views of candidate table for all admin"
    },
    'JOB_CSV_EXPORT_FIELD': {
        LABEL: 'Select Fields on Job CSV Export',
        DESCRIPTION: 'If left empty default fields will be used on exports'
    },
    'FULFILLMENT_EXCLUDE_STATUSES': {
        LABEL: 'Select Statuses to exclude for fulfillment calculation',
        DESCRIPTION: 'If left empty all statuses will be used in fulfillment calculation'
    },
    'SELECT_FIELDS_TABLE_VIEW': {
        LABEL: 'Select fields of table view',
        DESCRIPTION: 'If left empty default fields will be used on table'
    },
    'REVERSE_DEFAULT_DATE_SORT_ORDER_SHIFT_JOB_CALENDAR_TABLE_VIEW': {
        LABEL: 'Sort shift jobs in order of ascending date (old to new)',
    },
    'SHIFT_JOB_PAST_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the past to load job in Shift Job Calendar',
        DESCRIPTION: 'If not specified, the default value is 28'
    },
    'SHIFT_JOB_FUTURE_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the future to load job in Shift Job Calendar',
        DESCRIPTION: 'If not specified, the default value is 28'
    },
    'CANDIDATE_MY_JOBS_PAST_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the past to load job in My Job',
        DESCRIPTION: 'If not specified, the default value is 14'
    },
    'CANDIDATE_MY_JOBS_FUTURE_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the future to load job in My Job',
        DESCRIPTION: 'If not specified, the default value is 28'
    },
    'CANDIDATE_MY_SCHEDULE_PAST_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the past to load job in My Schedule',
        DESCRIPTION: 'If not specified, the default value is 14'
    },
    'CANDIDATE_MY_SCHEDULE_FUTURE_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the future to load job in My Schedule',
        DESCRIPTION: 'If not specified, the default value is 28'
    },
    'CANDIDATE_TABLE_SEARCH_FIELD': {
        LABEL: 'Quick search field for Candidate table of agency dashboard'
    },
    'EMPLOYER_TABLE_SEARCH_FIELD': {
        LABEL: 'Quick search field for Client table of agency dashboard'
    },
    'CANDIDATE_DEFAULT_SORT_FIELD': {
        LABEL: 'Default sort field for Candidate table of agency dashboard'
    },
    'EMPLOYER_DEFAULT_SORT_FIELD': {
        LABEL: 'Default sort field for Client table of agency dashboard'
    },
    'CANDIDATE_LAST_LOGIN_RETRIEVAL_DAYS': {
        LABEL: 'Number of last login retrieval days for Candidate table of agency dashboard'
    },
    'EMPLOYER_LAST_LOGIN_RETRIEVAL_DAYS': {
        LABEL: 'Number of last login retrieval days for Client table of agency dashboard'
    },
    'USER_STATUS_STATISTICAL_BREAKDOWN': {
        LABEL: 'Show user status statistical breakdowns'
    },
    HAS_SECOND_ADMIN_MANAGER: {
        LABEL: "Has Second Admin Manager"
    },
    LABEL_OF_ADMIN_MANAGER: {
        LABEL: "Label of Admin Manager"
    },
    STATUSES_INCLUDED_CANDIDATE_STATISTICS: {
        LABEL: 'Statuses to include in candidate status statistics'
    },
    STATUSES_INCLUDED_EMPLOYER_STATISTICS: {
        LABEL: 'Statuses to include in employer status statistics'
    },
    LABEL_OF_SECOND_ADMIN_MANAGER: {
        LABEL: "Label of Second Admin Manager"
    },
    'CANDIDATE_EACH_TYPE_COLOR': {
        LABEL: 'Color for each type in Candidate table'
    },
    'EMPLOYER_EACH_TYPE_COLOR': {
        LABEL: 'Color for each type in Client table'
    },
    'CANDIDATE_EACH_TAG_COLOR': {
        LABEL: 'Color for each tag in Candidate table'
    },
    'EMPLOYER_EACH_TAG_COLOR': {
        LABEL: 'Color for each tag in Client table'
    },
    'CANDIDATE_EACH_STATUS_COLOR': {
        LABEL: 'Color for each status in Candidate table'
    },
    'CANDIDATE_EACH_STATUS_APPLICATION_COLOR': {
        LABEL: 'Color for each status in applications table'
    },
    'EMPLOYER_EACH_STATUS_COLOR': {
        LABEL: 'Color for each status in Client table'
    },
    'PLACEMENT_JOB_TYPES_FIELD': {
        LABEL: 'Placement Job Types',
        DESCRIPTION: 'Do you have different types/categories of jobs? Please input them here.'
    },
    'PLACEMENT_JOB_STATUSES_FIELD': {
        LABEL: 'Placement Job Statuses',
        DESCRIPTION: 'Statuses that a placement (long term) job can have'
    },
    'SHIFT_JOB_STATUSES_FIELD': {
        LABEL: "Shift Job Statuses",
        DESCRIPTION: 'Statuses that a shift (short term) job can have'
    },
    REASON_FOR_CANCELLATION_SHIFT_JOB: {
        LABEL: "Reason for Cancellation Shift Job"
    },
    SHIFT_JOB_STATUSES_DO_NOT_BLOCK_AVAILABILTIY: {
        LABEL: "Shift job statuses which do not block an assigned candidate’s availability"
    },
    DO_NOT_ASK_FOR_REASON_CANCELLING_SHIFT_JOB: {
        LABEL: "Do not ask for reason when client cancels shift job"
    },
    'CANDIDATE_STATUS_TO_HIDE_DASHBOARD': {
        LABEL: 'Candidates in these Statuses will be hidden in the Candidates dashboard table.'
    },
    'EMPLOYER_STATUS_TO_HIDE_DASHBOARD': {
        LABEL: 'Clients in these statuses will be hidden in the Clients dashboard table.'
    },
    SHOW_CANDIDATE_DIALOG_IN_RIGHT_PANEL: {
        LABEL: "Do not show candidate dialog in full screen"
    },
    SHOW_EMPLOYER_DIALOG_IN_RIGHT_PANEL: {
        LABEL: "Do not show client dialog in full screen"
    },
    'EVALUATION_BUILDER_OUTCOME': {
        LABEL: 'Enable candidates to see outcome of evaluation',
    },
    'REQUEST_TIME_OFF_CATEGORIES': {
        LABEL: 'Time Off Request Categories',
    },
    'CANDIDATE_TOGGLE_TABLE_VIEW': {
        LABEL: 'Make candidate view of available jobs default to "Table view"',
    },
    'DO_NOT_SHOW_DUPLICATED_DOCUMENTS': {
        LABEL: 'Do not show duplicated document templates when updating status',
    },
    DEFAULT_FILTER_CANDIDATE_STATUS_SHIFT_JOB_BROADCAST: {
        LABEL: "Select default filter candidate statuses for shift job broadcast",
    },
    DEFAULT_FILTER_CANDIDATE_TYPES_SHIFT_JOB_BROADCAST: {
        LABEL: "Select default filter candidate types for shift job broadcast",
    },
    INITIAL_FILTER_LOCATION_BY_CLIENT_LOCATION: {
        LABEL: "Pre-set location in the location filter by job poster's location"
    },
    DEFAULT_FILTER_CANDIDATE_TAGS_SHIFT_JOB_BROADCAST: {
        LABEL: "Select default filter candidate tags for shift job broadcast",
    },
    HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_ALREADY_BOOKED: {
        LABEL: "When broadcasting shift job, check 'Already booked at this time' option by default",
    },
    DISABLE_SHIFT_JOB_DEFAULT_DISTANCE_SEARCH_ON_BROADCAST: {
        LABEL: "Disable distance based search for shift jobs by default"
    },
    DISABLE_PLACEMENT_JOB_DEFAULT_DISTANCE_SEARCH_ON_BROADCAST: {
        LABEL: "Disable distance based search for placement jobs by default"
    },
    HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_TIME_OFF: {
        LABEL: "When broadcasting shift job, check 'Who have time off at this time' option by default",
    },
    HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_NOT_AVAILABLE: {
        LABEL: "When broadcasting shift job, check 'Who are not available at this time' option by default",
    },
    HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_NO_MATCHING_TAG: {
        LABEL: "When broadcasting shift job, check 'Who's tags don't match' option by default",
    },
    HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_DO_NOT_MATCH_LIST: {
        LABEL: "When broadcasting shift job, check 'Who are on Do Not Match list' option by default",
    },
    DEFAULT_JOB_STATUS_SHIFT_JOB_CALENDAR: {
        LABEL: "Select default filter job statuses for Shift Job Calendar",
    },
    USE_MODAL_IN_APPLICATION_FORM: {
        LABEL: "Use pop up windows for adding information (eg. references, children, etc.) in application form"
    },
    DISBABLE_CONFIRM_CANCAL_POPUP_APPLICATION_FORM: {
        LABEL: "Disable confirm for cancelling popup in application form"
    },
    SHOW_MINIMUM_ENTRIES_REQUIRED_APPLICATION_FORM: {
        LABEL: "Show minimum number of entries (eg: references, children, etc.) in application form by default"
    },
    SELECT_FIELDS_MY_JOBS_TABLE: {
        LABEL: 'Select fields of "My Jobs" Table',
        DESCRIPTIONS: "If left empty default fields will be used on table"
    },
    CANDIDATE_CUSTOM_CLOCKOUT_MESSAGE: {
        LABEL: "Custom message for candidates on clockout"
    },
    HAS_REPORT_PROBLEM_BUTTON: {
        LABEL: "Has a button to let candidate report a problem for assigned shift job"
    },
    REPORT_PROBLEM_BUTTON_TEXT: {
        LABEL: "Text of the report problem button"
    },
    REPORT_PROBLEM_UPLOAD_FILE_LABEL: {
        LABEL: "Label of the upload files field in report problem dialog"
    },
    REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION: {
        LABEL: "Description of the upload files field in report problem dialog"
    },
    REPORT_PROBLEM_NOTE_LABEL: {
        LABEL: "Label of the note field in report problem dialog"
    },
    REPORT_PROBLEM_NOTIFICATION_EMAILS: {
        LABEL: "Notification emails when candidate report problem"
    },
    REPORT_PROBLEM_NEW_JOB_STATUS: {
        LABEL: "Job status to change to when candidate report problem",
        DESCRIPTION: "If don't change status, let it blank"
    },
    CLIENT_HAS_REPORT_PROBLEM_BUTTON: {
        LABEL: "Has a button to let client report a problem for posted shift job"
    },
    CLIENT_REPORT_PROBLEM_NOTIFICATION_EMAILS: {
        LABEL: "Notification emails when client report problem"
    },
    CLIENT_REPORT_PROBLEM_NEW_JOB_STATUS: {
        LABEL: "Job status to change to when client report problem",
        DESCRIPTION: "If don't change status, let it blank"
    },
    CUSTOM_CONFIRM_TEXT_ACCEPT_JOB: {
        LABEL: "Custom warning text before candidate accepts shift job"
    },
    CUSTOM_CONFIRM_TEXT_ACCEPT_JOB_BUTTON: {
        LABEL: 'Custom "Accept Job" button text'
    },
    CANDIDATE_CAN_MARK_CLIENT_AS_FAV: {
        LABEL: 'Candidates can mark clients as "Favorite"'
    },
    CANDIDATE_CAN_MARK_CLIENT_AS_DO_NOT_WANT_AGAIN: {
        LABEL: 'Candidates can mark clients as "Do not want again"'
    },
    EMPLOYER_CSV_EXPORT_SETTINGS: {
        LABEL: "Select Employer Fields on User Export",
        DESCRIPTION: "Drag and drop to reorder columns on the CSV"
    },
    EXPORT_DURATION_STATUS: {
        LABEL: "Select status to calculate Time in Status column"
    },
    CANDIDATE_CSV_EXPORT_SETTINGS: {
        LABEL: "Select Candidate Fields on User Export",
        DESCRIPTION: "Drag and drop to reorder columns on the CSV"
    },
    EMPLOYER_ANALYTICS_DASHBOARD_FIELDS: {
        LABEL: "Select default fields of analytics dashboard for client"
    },
    PLACEMENT_JOB_ANALYTICS_DASHBOARD_FIELDS: {
        LABEL: "Select default fields of analytics dashboard for placement job"
    },
    CANDIDATE_ANALYTICS_DASHBOARD_FIELDS: {
        LABEL: "Select default fields of analytics dashboard candidate"
    },
    QUICK_SEARCH_FIELDS_SHIFT_JOB_CALENDAR: {
        LABEL: "Quick search field for Shift Job Calendar"
    },
    INCLUDE_CANCELLING_REASON_CANDIDATE_EMAIL_SHIFT_JOB: {
        LABEL: "Include Cancellation Reason In Candidate Email when client cancels shift job"
    },
    DEFAULT_FILTER_CANDIDATE_STATUS_PLACEMENT_JOB_BROADCAST: {
        LABEL: "Placement job broadcast statuses",
        DESCRIPTION: "If this is empty, all candidates will receive placement job broadcasts."
    },
    DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_SHIFT_JOB_BROADCAST: {
        LABEL: "Select default filter candidate hide statuses for shift job broadcast",
    },
    DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_PLACEMENT_JOB_BROADCAST: {
        LABEL: "Select default filter candidate hide statuses for placement job broadcast",
    },
    SEND_EMAIL_TO_CLIENT_CANDIDATE_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send email to client when candidate assigned to shift job"
    },
    SEND_EMAIL_TO_CANDIDATE_CANDIDATE_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send email to candidate when assigned to shift job"
    },
    SEND_SMS_TO_CLIENT_CANDIDATE_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send SMS to client when candidate assigned to shift job"
    },
    SEND_SMS_TO_CANDIDATE_CANDIDATE_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send SMS to candidate when assigned to shift job"
    },
    SEND_EMAIL_TO_CLIENT_BULK_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send email notification to client when bulk assign shift job"
    },
    SEND_EMAIL_TO_CANDIDATE_BULK_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send email notification to candidate when bulk assign shift job"
    },
    SEND_SMS_TO_CLIENT_BULK_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send SMS notification to client when bulk assign shift job"
    },
    SEND_SMS_TO_CANDIDATE_BULK_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send SMS notification to candidate when bulk assign shift job"
    },
    DO_NOT_WARN_ABOUT_CANDIDATE_GENERAL_AVAILABILITY: {
        LABEL: "Do not warn about candidate general availability (you will still be warned about conflicts)"
    },
    SELECT_SHIFT_JOB_CALENDAR_FIELDS: {
        LABEL: "Select Fields of Shift Job Calendar",
    },
    SHIFT_JOB_CALENDAR_FIELDS_JOB_RESULT_INFO: {
        LABEL: "Select Fields of Shift Job Calendar (Job Result Information)",
    },
    CANDIDATE_STATUSES_SEE_PLACEMENT_JOBS: {
        LABEL: "Candidate statuses that can see placement jobs",
        DESCRIPTION: 'If this is empty, candidates in all statuses will be able see placement jobs'
    },
    CANDIDATE_STATUSES_SEE_SHIFT_JOBS: {
        LABEL: "Candidate statuses that can see shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all statuses will be able see shift jobs'
    },

    CANDIDATE_TAGS_SEE_SHIFT_JOBS: {
        LABEL: "Candidate tags that can see shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all tags will be able see shift jobs'
    },
    CANDIDATE_TYPES_SEE_SHIFT_JOBS: {
        LABEL: "Candidate types that can see shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all types will be able see shift jobs'
    },
    CANDIDATE_STATUSES_REQUEST_WORK_SHIFT_JOBS: {
        LABEL: "Candidate statuses that can request to work shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all statuses will be able to express interest in shift jobs.'
    },
    DEFAULT_VIEW_AVAILABLE_SHIFT_JOB_CALENDAR: {
        LABEL: "Default view of available shift job opportunities calendar",
    },
    CANDIDATE_TYPES_REQUEST_WORK_SHIFT_JOBS: {
        LABEL: "Candidate types that can request to work shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all types will be able to express interest in shift jobs.'
    },
    CANDIDATE_SELF_ASSIGN_THEMSELVES_SHIFT_JOBS: {
        LABEL: "Candidates can self assign themselves to shift jobs",
    },
    ONLY_ALLOW_CANDIDATE_TO_SEE_MATCHING_CATEGORY: {
        LABEL: "Only allow candidates to see jobs if their types includes the job category"
    },
    ONLY_ALLOW_CANDIDATE_TO_ACCEPT_MATCHING_CATEGORY: {
        LABEL: "Only allow candidates to accept jobs if their types includes the job category"
    },
    CANDIDATE_STATUSES_ACCEPT_SHIFT_JOBS: {
        LABEL: "Candidate statuses that can accept shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all statuses will be able to accept shift jobs.'
    },
    SCHEDULE_EVENT_TYPES: {
        LABEL: "Event Types",
    },
    BROADCAST_STATUSES_PLACEMENT_JOBS: {
        LABEL: "Placement job broadcast statuses",
        DESCRIPTION: 'If this is empty, all candidates will receive placement job broadcasts.'
    },
    HIDE_DISTANCE_FROM_JOB_CANDIDATE_VIEW_PLACEMENT_JOBS: {
        LABEL: 'Hide "Distance from job" when candidate views placement job'
    },
    JOB_FULL_WIDTH_BAR_STYLE_MODE: {
        LABEL: 'Job board full width bar styling (no photos and one job on one line)'
    },
    SHOW_JOB_IMAGE_IN_FULL_WIDTH_BAR_STYLE_MODE: {
        LABEL: 'Show image with job in full width bar styling mode'
    },
    SHOW_HIRED_BADGE_ON_JOB_BOARD: {
        LABEL: 'Show hired badge on job board'
    },
    SHOW_MAP_WITH_LOCATIONS_ON_JOB_BOARD_SHIFT_JOB: {
        LABEL: 'Show map with shift job locations on job board'
    },
    SHOW_MAP_WITH_LOCATIONS_ON_JOB_BOARD: {
        LABEL: 'Show map with placement job locations on job board'
    },
    SHOW_NOT_INTERESTED_PLACEMENT_JOBS: {
        LABEL: `Show "I'm not interested" button for placement job`
    },
    SHOW_MIGHT_BE_INTERESTED_PLACEMENT_JOBS: {
        LABEL: `Show "I might be interested" button for placement job`
    },
    NOTIFICATION_CLIENT_EXPRESS_INTEREST_CANDIDATE_PLACEMENT_JOBS: {
        LABEL: "Send notification email to client when a candidate expresses interest in their placement job"
    },
    CANDIDATE_SEE_PLACEMENT_JOBS_OUTSIDE_LOCATION: {
        LABEL: "Candidates can see placement jobs outside their location"
    },
    CANDIDATES_ACCEPT_JOB_WHEN_JOB_IS_BROADCASTED: {
        LABEL: "Candidates can accept job when job is broadcasted"
    },
    JOB_BOARD_LONG_TERM_PLACEMENT_JOBS_HEADING: {
        LABEL: "Job Board Long Term (Placement) Jobs Heading"
    },
    AVAILABLE_JOB_WITHIN_MILE_RADIUS_PLACEMENT_JOBS: {
        LABEL: "Show candidates placement jobs on the Available Job Board within this mile radius of their address",
        DESCRIPTION: 'If not specified, jobs in any distance will be showed'
    },
    EDITABLE_VIEW_DEFAULT: {
        LABEL: "Make editable view default"
    },
    SELECT_FIELDS_PLACEMENT_JOBS_DETAIL_VIEW: {
        LABEL: "Select fields for placement job detail view",
    },
    HAS_CLOCK_IN_CLOCK_OUT_BUTTON: {
        LABEL: "Hide clock in and clock out button"
    },
    MANUALLY_CLOCK_IN_CLOCK_OUT_JOBS: {
        LABEL: "Candidates manually clock in and out of jobs"
    },
    GET_USER_LOCATIONS_WHEN_CLOCK_IN_OUT: {
        LABEL: "Get candidate location clock in and out of jobs"
    },
    MINUTES_INTERVAL_CANDIDATE_CLOCK_IN_CLOCK_OUT: {
        LABEL: "Minutes Interval when candidate clock in and out"
    },
    HIDE_MILEAGE_QUESTION_CANDIDATE_CLOCK_OUT_SHIFT_JOB: {
        LABEL: "Hide mileage question when candidate clocks out of shift job"
    },
    CHARGE_TRANSFER_PRICE_PER_MILE: {
        LABEL: "How much they get per mile"
    },
    CHARGE_TRANSFER_INCLUDE_MILEAGE: {
        LABEL: "Include mileage when charge and transfer shift job"
    },
    HIDE_REIMBURSEMENT_QUESTION_CANDIDATE_CLOCK_OUT_SHIFT_JOB: {
        LABEL: "Hide reimbursement question when candidate clocks out of shift job"
    },
    CHARGE_TRANSFER_INCLUDE_REIMBURSEMENT: {
        LABEL: "Include reimbursement when charge and transfer shift job"
    },
    CANDIDATE_ABLE_CREATE_JOBS_TO_CLOCK_IN_OUT: {
        LABEL: "Do you want candidates to be able to create jobs for themselves to clock in and out of"
    },
    CLIENT_CAN_CONFIRM_CLOCK_IN_OUT_CANDIDATE_PHONE: {
        LABEL: "Client can confirm clock in/out on the candidate’s phone"
    },
    STATUS_JOB_CLIENT_CONFIRM_CLOCK_IN_OUT_TIME: {
        LABEL: "Status of Job after client confirm clock in and clock out time"
    },
    STATUS_JOB_CLIENT_DISAPPROVE_CLOCK_IN_OUT_TIME: {
        LABEL: "Status of Job after client disapprove clock in and clock out time"
    },
    CANDIDATE_CAN_MARK_JOB_AS_COMPLETED: {
        LABEL: "Candidates can mark jobs as completed"
    },
    MARK_JOB_COMPLETED_BUTTON_TEXT: {
        LABEL: "Text of the mark job as completed button"
    },
    STATUS_JOB_CANDIDATE_MARK_COMPLETED: {
        LABEL: "Status of Job after candidate mark job as completed"
    },
    NOTIFY_CANDIDATE_SHIFT_JOB_STARTING_IN_X_HOURS: {
        LABEL: "Notify a candidate of a shift job starting in X hours",
        DESCRIPTION: "If not set, don't notify candidate before shift job starting"
    },
    METHOD_NOTIFY_CANDIDATE_SHIFT_JOB_STARTING_IN_X_HOURS: {
        LABEL: "Method to Notify",
        DESCRIPTION: "Select Method to Notify candidate via"
    },
    NOTIFY_CANDIDATE_FOR_CLOCK_IN_MINUTES: {
        LABEL: "Send a reminder to candidate X minutes after scheduled clock in time if they have not done so",
        DESCRIPTION: "If not set, don't notify candidate for clock in"
    },
    NOTIFY_CANDIDATE_FOR_CLOCK_OUT_MINUTES: {
        LABEL: "Send a reminder to candidate X minutes after scheduled clock out time if they have not done so",
        DESCRIPTION: "If not set, don't notify candidate for clock out"
    },
    METHOD_NOTIFY_CLOCK_IN_OUT: {
        LABEL: "Method to Notify Candidate for Clock In/Out",
        DESCRIPTION: "Select Method to Notify candidate via"
    },
    RECORD_BREAK_ITEMS_DURING_SHIFTS: {
        LABEL: "Add option to record break times during shifts"
    },
    CANDIDATE_CAN_SUBMIT_SHIFT_JOB_REPORT: {
        LABEL: "Candidate can submit shift job report"
    },
    SUBMIT_SHIFT_JOB_REPORT_MANDATORY_BEFORE_CLOCKOUT: {
        LABEL: "Shift job report is mandatory BEFORE clock-out"
    },
    CANDIDATE_NOT_ALLOW_REVIEW: {
        LABEL: "Don’t allow candidates to leave reviews"
    },
    SHIFT_JOB_REPORT_ADMIN_ONLY: {
        LABEL: "Shift job report is admin only"
    },
    CUSTOMIZE_SUBMIT_REPORT_BUTTON_LABEL: {
        LABEL: 'Customize "Submit Report" button label'
    },
    ADMIN_EMAIL_NOTIFICATION_SHIFT_JOB_REPORT: {
        LABEL: "Admin emails notified when shift job report submitted"
    },
    SELECT_DEFAULT_CANDIDATE_STATUSES_APPEAR_ASSIGNING_CANDIDATE: {
        LABEL: "Select candidate Statuses which appear in shift job candidate assignment dropdown"
    },
    SELECT_DEFAULT_CANDIDATE_TYPES_APPEAR_ASSIGNING_CANDIDATE: {
        LABEL: "Select candidate Types which appear in shift job candidate assignment dropdown"
    },
    PREVENT_CANDIDATE_FROM_INPUTTING_DAILY_AVAILABILITY: {
        LABEL: "Prevent candidates from inputting daily availability"
    },
    USE_TIMEOFF_CREDIT: {
        LABEL: "Use Timeoff Credit"
    },
    SHOW_PRICE_MANAGER_ON_ADMINISTRATORS_TABLE: {
        LABEL: "Show Price Manager on administrators table"
    },
    NOTIFY_EMAILS_RECURRING_AVAILABILITY: {
        LABEL: "Emails that receive a notification when recurring availability is entered or edited"
    },
    ALLOW_CANDIDATE_TO_EDIT_RECURRING_AVAILABILITY: {
        LABEL: "Allow candidates to edit recurring availability"
    },
    NUMBER_OF_WEEKS_CANDIDATE_CANNOT_CHANGE_WEEK_AVAILABILITY: {
        LABEL: "Number of weeks in which candidate cannot change week availability?",
        DESCRIPTION: "Default value is 0"
    },
    WORD_USED_FOR_MY_PROFILE: {
        LABEL: 'Word used for "My Profile"'
    },
    WORD_USED_FOR_AVAILABLE_JOBS: {
        LABEL: 'Word used for "Available Jobs"'
    },
    WORD_USED_FOR_MY_SCHEDULE: {
        LABEL: 'Word used for "My Schedule"'
    },
    WORD_USED_FOR_MY_JOBS: {
        LABEL: 'Word used for "My Jobs"'
    },
    WORD_USED_FOR_MY_FAMILIES: {
        LABEL: 'Word used for "My Families"'
    },
    WORD_USED_FOR_SHIFT_JOB_CALENDAR: {
        LABEL: 'Word used for "Shift Job Calendar"'
    },
    WORD_USED_FOR_PLACEMENT_JOB: {
        LABEL: 'Word used for "Placement Jobs"'
    },
    WORD_USED_FOR_CANDIDATE: {
        LABEL: 'Word used for "Candidate"'
    },
    WORD_USED_FOR_CANDIDATES: {
        LABEL: 'Word used for "Candidates" (Plural)'
    },
    WORD_USED_FOR_CLIENT: {
        LABEL: 'Word used for "Client"'
    },
    WORD_USED_FOR_CLIENTS: {
        LABEL: 'Word used for "Clients" (Plural)'
    },
    CUSTOMIZE_CANDIDATE_CLIENT_RELATIONSHIP_STATUS: {
        LABEL: "Customize candidate-client relationship status"
    },
    PLACEMENT_JOB_APPLICATION_STATUS_TO_ADD_RELATIONSHIP: {
        LABEL: "Default statuses of placement job application in which a corresponding relationship will be created when adding/editing job application"
    },
    DO_NOT_AUTO_POPULATE_ADDRESS: {
        LABEL: 'Do not auto populate address'
    },
    SELECT_MINUTES_INTERVAL_BOOKING_TIME: {
        LABEL: 'Select Minutes Interval for booking time in Client Profile or Application Form'
    },
    SELECT_MINUTES_INTERVAL_SHIFT_JOB_CALENDAR: {
        LABEL: "Minutes Interval when Admins Add new Bookings in the Shift Job Calendar"
    },
    PLACEMENT_JOB_REVENUE_FIELD: {
        LABEL: "Select revenue field of placement job"
    },
    CANDIDATE_CAN_EDIT_BUFFER_TIME: {
        LABEL: "Candidates can edit buffer time"
    },
    FILLER_IN_MONTH_START_DAY: {
        LABEL: "Start day of month to calculate filler number in month"
    },
    CANDIDATE_TAGS_MATCHING_OPTIONS_SCHEDULER_VIEW: {
        LABEL: "How to use candidate tags filter in scheduler view"
    },
    CANDIDATE_TAGS_MATCHING_CANDIDATE_TABLE_SETTINGS: {
        LABEL: "How to use candidate tags filter in Candidate table"
    },
    PUBLIC_JOB_START_DATE_LABEL: {
        LABEL: "Start Date Label"
    },
    PUBLIC_JOB_END_DATE_LABEL: {
        LABEL: "End Date Label"
    },
    PUBLIC_JOB_START_TIME_LABEL: {
        LABEL: "Start Time Label"
    },
    PUBLIC_JOB_END_TIME_LABEL: {
        LABEL: "End Time Label"
    },
    JOB_STATUSES_TO_HIDE_FROM_SCHEDULER_VIEW: {
        LABEL: 'Select jobs statuses to hide from scheduler view',
    },
    DEFAULT_FILTER_CANDIDATE_TYPES_SCHEDULER_VIEW: {
        LABEL: 'Select default filter candidate types for scheduler view',
    },
    DEFAULT_FILTER_CANDIDATE_STATUSES_SCHEDULER_VIEW: {
        LABEL: 'Select default filter candidate statuses for scheduler view',
    },
    DEFAULT_FILTER_CANDIDATE_TAGS_SCHEDULER_VIEW: {
        LABEL: 'Select default filter candidate tags for scheduler view ',
    },
    SHIFT_JOB_STATUS_AFTER_DRAG_DROP_TO_ASSIGN: {
        LABEL: "Shift job status after drag and drop a job to candidate in scheduler view"
    },
    USE_BOOKED_TIME_IF_NO_CLOCKED_TIME: {
        LABEL: "Use booked times if no clocked times"
    },
    CUSTOM_CONFIRM_TEXT_CLIENT_CANCEL_SHIFT_JOB: {
        LABEL: "Custom text when a client cancels a shift job"
    },
    CUSTOM_TEXT_MESSAGE_SHIFT_JOB_ACCEPTED: {
        LABEL: "Custom text message when a shift job is accepted"
    },
    DISCLAIMER_TEXT_ADDING_BOOKING: {
        LABEL: "Disclaimer text when adding a booking"
    },
    CUSTOM_CONFIRM_TEXT_CLIENT_CANCEL_SHIFT_JOB: {
        LABEL: "Custom text when a client cancels a shift job"
    },
    REMOVE_CANDIDATE_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON: {
        LABEL: "Remove option for candidates to upload additional documents"
    },
    AGENCY_GETS_NOTIFIED_WHEN_CANDIDATE_UPLOAD_ANY_DOCUMENT: {
        LABEL: "Agency gets notified when candidate upload any document"
    },
    REMOVE_CLIENT_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON: {
        LABEL: "Remove option for clients to upload additional documents"
    },
    'SHIFT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS': {
        LABEL: 'Fields which are visible in candidate table when broadcasting a shift job',
        DESCRIPTION: 'Drag and drop fields to re-order.'
    },
    'PLACEMENT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS': {
        LABEL: 'Fields which are visible in candidate table when broadcasting a placement job',
        DESCRIPTION: 'Drag and drop fields to re-order.'
    },
    'PLACEMENT_OF_PRICE_INFO_FIELDS': {
        LABEL: 'Rearrange the order the rates appear for clients in a booking',
        DESCRIPTION: 'Drag and drop fields to re-order.'
    },
    DEFAULT_HIDDEN_PLACEMENT_JOB_STATUSES: {
        LABEL: "Placement job statuses that are hidden from the job board"
    },
    NOTIFY_AGENCY_USER_EDIT_DOCUMENT_ADDITIONAL_INFO: {
        LABEL: "Notify agency when user edits a document that has an expiration date"
    },
    SELECT_ZOOM_LEVEL_OF_JOB_MAP: {
        LABEL: 'Select Zoom Level of the Map',
        DESCRIPTION: 'Select a number between 1 to 20 (far to closer), Default value is 13.'
    },
    SELECT_FIELDS_OF_CLIENT_SHIFT_JOB_PROFILE: {
        LABEL: "Select Fields of Client Shift Job Profile"
    },
    SELECT_FIELDS_OF_CLIENT_SHIFT_JOB_PROFILE_TO_ASSIGNEE: {
        LABEL: "Select Fields of Client Shift Job Profile (Show to assignee)"
    },
    SHOW_CLIENT_PROFILE_ON_JOB_LISTING: {
        LABEL: "Show client profile on job listings"
    },
    SHOW_CLIENT_PROFILE_ON_JOB_LISTING_TO_ASSIGNEE_ONLY: {
        LABEL: "Show client profile on job listings ONLY to assigned candidate"
    },
    CANDIDATE_STATUSES_CAN_VIEW_CLIENT_PROFILE: {
        LABEL: "Candidate statuses which can view client profile",
        DESCRIPTION: "If none are selected then they all will"
    },
    CANDIDATE_TYPES_CAN_VIEW_CLIENT_PROFILE: {
        LABEL: "Candidate types which can view client profile",
        DESCRIPTION: "If none are selected then they all will"
    },
    SELECT_FIELDS_OF_SHIFT_JOB_CANDIDATE_VIEW: {
        LABEL: "Select fields of shift job for candidate view"
    },
    STATUS_HIDDEN_PAST_DATE_SHIFT_JOB_CALENDAR: {
        LABEL: "Shift job statuses hidden for past dates on shift job calendar"
    },
    SHIFT_JOB_FIELD_TO_SHOW_TO_CANDIDATE: {
        LABEL: "Shift job fields to show to candidate"
    },
    CLIENT_ADD_NOTE_ASSIGNED_CANDIDATE_NOTIFICATION_EMAILS: {
        LABEL: "Notification emails when client adds a note about an assigned candidate "
    },
    WORD_USED_FOR_SCHEDULE_INTERVIEW_RELATIONSHIP: {
        LABEL: 'Word used for "Schedule Interview"'
    },
    SHOW_SHAREABLE_LINK_FOR_MY_CANDIDATES_SECTION: {
        LABEL: `Show shareable link for "My Candidates" section`
    },
    'HIDE_SHIFT_JOB_DUPLICATE_BUTTON': {
        LABEL: 'Hide shift job duplicate button'
    },
    "SHIFT_JOB_CALENDAR_HIDE_UNAVAILABLE_CANDIDATES": {
        LABEL: "For candidate list in shift job calendar, hide unavailable candidates by default"
    },
    'HIDE_SHIFT_JOB_UPDATE_MANAGER_SECTION': {
        LABEL: 'Hide shift job update manager section'
    },
    'HIDE_SHIFT_JOB_NOTES_SECTION': {
        LABEL: 'Hide shift job notes section'
    },
    NOTIFY_EMAILS_PACKAGE_SELECTION_CHANGE: {
        LABEL: "Emails that receive a notification when package is selected or changed"
    },
    'DEFAULT_FILTER_CLIENT_TYPES_SHIFT_JOB_CALENDAR': {
        LABEL: 'Select default filter client types for Shift Job Calendar'
    },
    'DEFAULT_FILTER_CLIENT_STATUSES_SHIFT_JOB_CALENDAR': {
        LABEL: 'Select default filter client statuses for Shift Job Calendar'
    },
    SEND_EMAIL_NOTIFICATION_WHEN_UNASSIGN_CANDIDATE: {
        LABEL: "Send email notification to candidate when unassigning job"
    },
    CANDIDATE_TYPES_CANNOT_EDIT_RECURRING_AVAILABILITY: {
        LABEL: "Candidate types that cannot edit their recurring availability.",
        DESCRIPTION: "If this is empty, candidates in all types will be able to edit their recurring availability"
    },
    SHOW_ANALYTICS_BY_DEFAULT_PLACEMENT_JOBS: {
        LABEL: "Show analytics by default"
    },
    PLACEMENT_JOB_CUSTOM_FILTER: {
        LABEL: "Select fields for custom filter for placement jobs"
    },
    CANDIDATE_STATUSES_SEE_PLACEMENT_JOBS: {
        LABEL: "Candidate statuses that can see placement jobs",
        DESCRIPTION: 'If this is empty, candidates in all statuses will be able see placement jobs'
    },
    CANDIDATE_TYPES_SEE_PLACEMENT_JOBS: {
        LABEL: "Candidate types that can see placement jobs",
        DESCRIPTION: 'If this is empty, candidates in all types will be able see placement jobs'
    },
    RELATIONSHIP_STATUSES_HIDDEN_IN_MY_CANDIDATES: {
        LABEL: "Candidate client relationship statuses which are not showed in 'My Candidates' section"
    },
    'RELATIONSHIP_STATUSES_WHERE_EXTEND_OFFER_BUTTON_APPEARS': {
        LABEL: 'Candidate client relationship statuses where the Extend Offer button appears for the client'
    },
    HIDE_VIEW_PREVIOUS_JOB_APPLICATIONS: {
        LABEL: 'Hide "View Previous Job Applications" in "Available Jobs"'
    },
    ALLOW_USE_MOBILE_APP: {
        LABEL: "Allow client and candidate to use android & ios mobile app"
    },
    ENABLE_PLACEMENT_JOB_MOBILE_APP: {
        LABEL: "Enable placement jobs in mobile app"
    },
    CANDIDATE_SEARCH_BAR_OPEN_BY_DEFAULT: {
        LABEL: "The 'Search and Tool' panel of Candidate dashboard opens by default"
    },
    EMPLOYER_SEARCH_BAR_OPEN_BY_DEFAULT: {
        LABEL: "The 'Search and Tool' panel of Employer dashboard opens by default"
    },
    USE_CHAT_FEATURE: {
        LABEL: "Use chat feature"
    },
    CHAT_BETWEEN_CLIENT_AND_CANDIDATE_SHIFT_JOB: {
        LABEL: "Enable chat between candidate and client when candidate assigned to shift job"
    },
    CHAT_BETWEEN_CLIENT_AND_CANDIDATE_PLACEMENT_JOB: {
        LABEL: "Enable chat between candidate and client when candidate assigned to placement job"
    }
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/agency-settings/en.js